var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('authorization',{attrs:{"permissionKey":"island_therapy_queue","can":"read"}},[_c('Attendances',{attrs:{"queueType":"therapy_exam","attendancePlaceId":_vm.attendancePlaceId},scopedSlots:_vm._u([{key:"attendance",fn:function(ref){
var attendance = ref.attendance;
return [_c('AttendanceTherapyList',{attrs:{"attendance":attendance}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }